import type { AllDiffusionRecipientDto } from '@monorepo/shared';

interface RecipientRowProps {
  recipient: AllDiffusionRecipientDto;
  isSelected: boolean;
  onToggle: () => void;
  t: (key: string) => string;
}

const getInitials = (firstName: string, lastName: string) => {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
};

export const RecipientRow = ({ recipient, isSelected, onToggle, t }: RecipientRowProps) => {
  const { firstName, lastName, email, hasOpened, groupName } = recipient;
  const initials = getInitials(firstName, lastName);

  return (
    <tr className="border-b border-gray-100 last:border-b-0">
      <td className="px-3 py-2.5">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onToggle}
          className={`w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary ${hasOpened ? 'opacity-50' : ''}`}
        />
      </td>
      <td className="px-3 py-2.5">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-xs font-medium text-gray-900">
            {initials}
          </div>
          <div className="flex flex-col">
            <span className="text-xs font-medium text-gray-900">
              {lastName} {firstName}
            </span>
            <span className="text-[10px] text-gray-500">{email}</span>
          </div>
        </div>
      </td>
      <td className="px-3 py-2.5">
        {hasOpened ? (
          <span className="inline-flex px-2 py-0.5 text-xs font-normal rounded-md bg-green-100 text-green-700">
            {t('documents.resend_modal.status.opened')}
          </span>
        ) : (
          <span className="inline-flex px-2 py-0.5 text-xs font-normal rounded-md bg-gray-200 text-gray-600">
            {t('documents.resend_modal.status.not_opened')}
          </span>
        )}
      </td>
      <td className="px-3 py-2.5">
        {groupName && (
          <span className="inline-flex px-2 py-0.5 text-xs font-normal rounded-md bg-gray-200 text-gray-600">
            {groupName}
          </span>
        )}
      </td>
    </tr>
  );
};
